import Services from "../components/sections/Services";
import TechStack from "../components/sections/TechStack";
import { motion } from "framer-motion";
import useSEO from "../lib/useSEO";

export default function ServicesPage() {
    useSEO({
        title: "Services — ERP, Accounting, Mobile, SaaS & Cloud Software Development | Thooyra",
        description:
            "Custom ERP, accounting software, billing & POS, inventory, mobile apps, SaaS platforms, cloud, DevOps, API integrations, UI/UX and business automation — engineered by Thooyra in Chennai.",
        path: "/services",
    });
    return (
        <main data-testid="services-page">
            <section className="relative pt-36 pb-12 md:pt-44 md:pb-16 overflow-hidden">
                <div
                    aria-hidden
                    className="absolute inset-0 -z-10 pointer-events-none"
                >
                    <div className="absolute top-10 right-10 w-[420px] h-[420px] rounded-full bg-blue-300/30 dark:bg-blue-500/20 blur-[120px] animate-blob" />
                </div>
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <motion.div
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                            Services
                        </div>
                        <h1 className="font-display font-light text-5xl md:text-7xl tracking-tighter leading-[1.02] max-w-4xl">
                            Full-stack software services for{" "}
                            <span className="italic font-medium">
                                modern businesses
                            </span>
                            .
                        </h1>
                        <p className="mt-8 max-w-2xl text-muted-foreground text-lg leading-relaxed">
                            Pick and choose what your business needs — from a
                            single API integration to a complete ERP build.
                        </p>
                    </motion.div>
                </div>
            </section>
            <Services />
            <TechStack />
        </main>
    );
}
